<template>
	<button
		v-if="monthlyPayment"
		type="button"
		class="text-sm tracking-xl hover:underline focus:underline"
		@click="isOpen = true"
		@keypress="isOpen = true"
	>
		<div class="flex flex-row items-center">
			<v-icon icon="empty-wallet-change" class="mr-xs text-lg" />

			<p>{{ t("product-part-payment") }} &nbsp;</p>

			<b>
				{{ t("product-part-payment-prefix") }}
				{{ formatCurrency(monthlyPayment) }}
				{{ t("product-part-payment-suffix") }}
			</b>
		</div>
	</button>

	<client-only>
		<lazy-v-page-product-installments-modal
			:is-open="isOpen"
			:price="price"
			@close="isOpen = false"
		/>
	</client-only>
</template>

<script lang="ts" setup>
import {useCurrency} from "@pkg/shared/composables/use-currency";

const properties = defineProps<{
	price: string;
}>();

const {format: formatCurrency} = useCurrency();

const {t} = useI18n();

const isOpen = ref(false);

function getMonthlyPayment(
	price: number,
	months: number,
	statementFee: number,
	yearInterestRate: number,
): number {
	const value =
		Math.round(
			((yearInterestRate / 1200 +
				yearInterestRate /
					1200 /
					((1 + yearInterestRate / 1200) ** months - 1)) *
				price *
				100) /
				100,
		) + statementFee;
	return Math.max(value, 8);
}

const monthlyPayment = computed<number | undefined>(() =>
	properties.price
		? getMonthlyPayment(Number(properties.price), 36, 3.95, 19)
		: undefined,
);
</script>

<i18n lang="json">
{
	"et": {
		"product-part-payment": "Maksa osade kaupa ",
		"product-part-payment-prefix": "al.",
		"product-part-payment-suffix": "/kuu"
	},
	"fi": {
		"product-part-payment": "Maksa erissä",
		"product-part-payment-prefix": "alk.",
		"product-part-payment-suffix": "/kk"
	}
}
</i18n>
